// Modules
import Modal from 'js/modules/module-modal';
import Page from 'js/modules/module-page';

// Plugins
import 'js/plugins/lazyload.js';

// CSS
import 'sass/pages/page-home.scss';

jQuery(function ($) {
  $(document).ready(function () {
    new Page($('#body'));

    $('[data-rooster-modal]').each((i, modal) => {
      new Modal($(modal));
    });
  });
});
